import { render, staticRenderFns } from "./ROT.vue?vue&type=template&id=5d4911d6&scoped=true&"
import script from "./ROT.vue?vue&type=script&lang=js&"
export * from "./ROT.vue?vue&type=script&lang=js&"
import style0 from "./ROT.vue?vue&type=style&index=0&id=5d4911d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4911d6",
  null
  
)

export default component.exports